import { EstateId } from '@contexts/Estate/EstateApplication/domain';
import { EstateDetails, useEstateActions } from '@contexts/Estate/Shared';
import { Response } from '@shared/models';
import { useEffect, useState } from 'react';

export const useLoadEstatesHook = () => {
  const { result: estateResult, get: getEstate } =
    useEstateActions().listingDetailsQueryActions.useGetEstateListingDetailsByEstateId();

  const [estateIds, setEstateIds] = useState<EstateId[]>([]);

  const [estates, setEstates] = useState<EstateDetails[]>([]);

  useEffect(() => {
    if (Response.isSucceed(estateResult)) {
      setEstates((prev) => [...prev, estateResult.result]);
    }
  }, [estateResult]);

  useEffect(() => {
    if (estateIds.length > 0) {
      setEstateIds((prev) => [...prev.slice(1)]);
    }
  }, [estates.length]);

  useEffect(() => {
    if (estateIds.length > 0) {
      getEstate({
        estateId: estateIds[0],
      });
    }
  }, [estateIds.length]);

  const getAllLoaded = () =>
    !estateIds.map((estateId) => estates.some((estate) => estate.id === estateId.value)).includes(false);

  return {
    action: (estateIds: EstateId[]) => setEstateIds(() => estateIds),
    estates,
    loading: (estateIds.length < 1 ? 'NOT_PERFORMED' : getAllLoaded() ? 'LOADED' : 'LOADING') as
      | 'LOADED'
      | 'NOT_PERFORMED'
      | 'LOADING',
  };
};
